/// <reference path="../../../microsoftmaps/microsoft.maps.all.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import { RCUtils } from './../RCUtils';
import * as MapCallouts from './../components/childcomponents/BingMapCallouts';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
import * as RCNGWindow from '../components/sharedcomponents/ConfirmationWindow';
import GeofenceManagement from '../components/routecomponents/GeofenceManagement';
import { initialize, whenLoaded } from "bing-maps-loader";

//import { loadBingApi, Microsoft } from "../actions/BingMapLoader";
//import '../actions/bingmaps.api';
//require('../actions/bingmaps.api.js');
var pinInfobox = null;
var geofenceMap = null;
var fenceLayer = null;
var Config: any = require('../Config.json');

var drawingFinishedEventHandler = null;
//var drawingStartedEventHandler = null;
var GeofencesData = [];
var drawingTools = null;
//var drawingManager = null;
var currentShape;
var currentMode = null;
var currentFence = null;
var events = [];
var autoSuggestManager = null;
var flag = false;

class GeofenceMap {
    static InitializeMap(params: any) {    
        whenLoaded.then(() => {
            geofenceMap = new Microsoft.Maps.Map(document.getElementById(params), {
                credentials: Config.BingMapsKey,
                mapTypeId: Microsoft.Maps.MapTypeId.road,
                zoom: 4,
                showMapTypeSelector: true,
                disableKeyboardInput: true,
                liteMode: true
            });

            //Load the DrawingTools and SpatialMath modules.
            Microsoft.Maps.loadModule(['Microsoft.Maps.DrawingTools', 'Microsoft.Maps.SpatialMath'], function () {

                drawingFinishedEventHandler = Microsoft.Maps.Events.addHandler(geofenceMap, 'dblclick', function (args) { drawingFinished(args); });

                //Create an instance of the DrawingTools class and bind it to the map.
                drawingTools = new Microsoft.Maps.DrawingTools(geofenceMap);

            });
        });

    }

    static InitializeDrawingManager() {
        whenLoaded.then(() => {
            if (drawingTools != null && drawingTools != undefined) {
                //Load the DrawingTools and SpatialMath modules.
                Microsoft.Maps.loadModule(['Microsoft.Maps.DrawingTools', 'Microsoft.Maps.SpatialMath'], function () {

                    drawingFinishedEventHandler = Microsoft.Maps.Events.addHandler(geofenceMap, 'dblclick', function (args) { drawingFinished(args); });

                    //Create an instance of the DrawingTools class and bind it to the map.
                    drawingTools = new Microsoft.Maps.DrawingTools(geofenceMap);

                });
            }
            //Load the AutoSuggest module.
            Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', function () {
                var options = {
                    maxResults: 4,
                    map: geofenceMap,
                    businessSuggestions: true,
                    autoDetectLocation: false
                };
                autoSuggestManager = new Microsoft.Maps.AutosuggestManager(options);
                autoSuggestManager.attachAutosuggest('#txtSearchBox', '#searchBoxContainer', selectedSuggestion);
            });
        });
    }
    
    static pointInPolygon(polygon) {
        var inside = false;
        var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);
        //var intersects = Microsoft.Maps.SpatialMath.Geometry.intersects(center, polygon);
        var x = center.latitude, y = center.longitude;

        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i].latitude, yi = polygon[i].longitude;
            var xj = polygon[j].latitude, yj = polygon[j].longitude;

            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }

    static BindGeofencePolygons(fences) {
        if (fenceLayer != null)
            fenceLayer.clear();

        GeofencesData = [];
        GeofencesData = fences;

        //Create a layer for the drawn shapes.
        fenceLayer = new Microsoft.Maps.Layer();

        //Clear map infobox
        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
            pinInfobox.setMap(null);
        }

        //Create an infobox at the center of the map but don't show it.
        pinInfobox = new Microsoft.Maps.Infobox(geofenceMap.getCenter(), {
            visible: false
        });
        //Assign the infobox to a map instance.
        pinInfobox.setMap(geofenceMap);

        $.each(fences, function (selectedIndex, selectedValue) {
            var exteriorRing = selectedValue.FormatedCoordinates;
            var selectedFence = selectedValue;
            var polygon;
            if (selectedValue.GeofenceCategoryCd == "B")
                polygon = new Microsoft.Maps.Polygon(exteriorRing, { strokeDashArray: [1, 3] });
            else
                polygon = new Microsoft.Maps.Polygon(exteriorRing, null);         
            fenceLayer.add(polygon);

            Microsoft.Maps.Events.addHandler(polygon, 'mousedown', function (args) { displayFenceInfoboxOnClick(args, selectedFence, polygon); });
        });

        geofenceMap.layers.insert(fenceLayer);
    }

    static SetDrawingMode(mode, elm) {
        //clearSelection('DrawingModes', 'btn btn-secondary editButton');
        //elm.className = 'btn btn-outline-secondary active';
        clearSelection('DrawingModes', 'btn btn-outline-secondary');
        currentFence = null;
        if (mode == "polygon") {
            if (currentMode != mode) {
                document.getElementById("DrawPolygonMode").className = 'btn btn-outline-secondary active';
                $("#AddGeofenceMode").show();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                drawPolygon();
            }
            else {
                document.getElementById("DrawPolygonMode").className = 'btn btn-outline-secondary';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                drawPolygon();
            }
        }
        else if (mode == "edit") {
            if (currentMode != mode) {
                document.getElementById("EditPolygonMode").className = 'btn btn-outline-secondary active';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").show();
                $("#DeleteGeofenceMode").hide();
                edit();
            }
            else {
                document.getElementById("EditPolygonMode").className = 'btn btn-outline-secondary';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                edit();
            }
        }
        else if (mode == "erase") {
            if (currentMode != mode) {
                document.getElementById("DeletePolygonMode").className = 'btn btn-outline-secondary active';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").show();
                erase();
            }
            else {
                document.getElementById("DeletePolygonMode").className = 'btn btn-outline-secondary';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                erase();
            }
        }

    }

    static DisposeDrawingManager() {
        if (fenceLayer != null) {
            fenceLayer.clear();           

            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }
        }
        if (drawingTools != null && drawingTools != undefined) {
            drawingTools.dispose();             
            //Remove event handlers. 
            Microsoft.Maps.Events.removeHandler(drawingFinishedEventHandler);
            setMode(null);
        }

        if (autoSuggestManager != null && autoSuggestManager != undefined) {
            autoSuggestManager.dispose();
            $("#txtSearchBox").val(null);
        }        
    }

    static ShowSelectedGeofence(selectedRow: any) {
        var dataItem = null;
        
        for (var i = 0; i < GeofencesData.length; i++) {
            if (GeofencesData[i].GeofenceHistoryID.toString() == selectedRow.GeofenceHistoryID.toString()) {
                dataItem = GeofencesData[i];
                break;
            }
        }

        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
            pinInfobox.setMap(null);
        }

        var exteriorRing = dataItem.FormatedCoordinates;
        var polygon = new Microsoft.Maps.Polygon(exteriorRing, null);

        var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);
        var popOffset = new Microsoft.Maps.Point(-4, 100);
        var identityCode = GenerateAlphaNumericCode(6);
        /* InfoBox Code Starts     */
        var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
        var DescElement = React.createElement(MapCallouts.PinInfoboxFenceLocation, { selectedPin: dataItem, divid: identityCode, source: "GeofenceMgmt" });
        RCUtils.RenderChildComponent(identityCode, DescElement);
        // Create the infobox for the pushpin
        pinInfobox.setOptions({
            maxHeight: 80,
            maxWidth: 540,
            showPointer: true,
            description: description,
            location: new Microsoft.Maps.Location(center.latitude, center.longitude),
            visible: true, offset: popOffset,
            showCloseButton: true
        });

        //geofenceMap.setView({
        //    center: center,
        //    zoom: 12
        //});

        var bound = Microsoft.Maps.LocationRect.fromLocations(exteriorRing);
        geofenceMap.setView({ bounds: bound, center: center, padding: 100 });

        pinInfobox.setMap(geofenceMap);

        //showGeofencePanelData(dataItem.Coordinates);
    }

    static CancelDrawing() {
        //fenceLayer.remove(currentShape);
        if (!flag) {
            drawingTools.dispose();
            drawingTools = new Microsoft.Maps.DrawingTools(geofenceMap);
            currentMode = null;
            currentShape = null;
            clearSelection('DrawingModes', 'btn btn-outline-secondary');
            $("#AddGeofenceMode").hide();
            $("#EditGeofenceMode").hide();
            $("#DeleteGeofenceMode").hide();
        }
    }

    static ContinueDrawing() {
        flag = true;
        currentMode = 'edit';
        document.getElementById("DrawPolygonMode").className = 'btn btn-outline-secondary';
        document.getElementById("EditPolygonMode").className = 'btn btn-outline-secondary active';
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").show();
        $("#DeleteGeofenceMode").hide();
    }

    static resetFlag() {
        flag = false;
    }

    static ResetDrawing() {
        resetDrawing();
    }  

    static EraseMode() {
        eraseMode();
    }
}

//function showGeofencePanelData(coordinates) {
//    var coordinatesHtml = "";
//    $.each(coordinates, function (index, value) {
//        coordinatesHtml += '<span>' + value.Latitude + ', ' + value.Longitude + '</span></br>';
//    });
   
//    $("#panelCoordinates").html(coordinatesHtml);   
//}

function selectedSuggestion(suggestionResult) {
    geofenceMap.entities.clear();

    geofenceMap.setView({ bounds: suggestionResult.bestView });
}

//Removes the selected state for the style options.
function clearSelection(parentId, className) {
    var parent = document.getElementById(parentId);
    if (parent != null && parent!=undefined) {
    for (var i = 0; i < parent.children.length; i++) {
        parent.children[i].className = className;
    }
}
}

var style = {
    color: 'purple',
    fillColor: 'rgba(0,255,0,0.5)',
    strokeColor: 'blue',
    strokeThickness: 1
};

function drawPolygon() {
    if (setMode('polygon')) {
        //Create a new polygon.
        drawingTools.create(Microsoft.Maps.DrawingTools.ShapeType.polygon, function (s) {
            s.setOptions(style);
            currentShape = s;
        });
    }
}

function edit() {
    if (setMode('edit')) {
        //Enable pushpin dragging in layer.
        setPushpinDraggability(true);
        events.push(Microsoft.Maps.Events.addHandler(fenceLayer, 'click', function (e) {
            resetDrawingState();
            currentShape = e.primitive;
            //if (e.primitive.metadata && e.primitive.metadata.type === 'circle') {
            //    editCircle(e);
            //} else if (e.primitive.metadata && e.primitive.metadata.type === 'rectangle') {
            //    editRectangle(e);
            //}
            if (e.primitive instanceof Microsoft.Maps.Polygon) {
                //Remove the shape from the map as the drawing tools will display it in the drawing layer.
                fenceLayer.remove(e.primitive);
                //Pass the shape to the drawing tools to be edited.
                drawingTools.edit(e.primitive);
            }
        }));
    } else {
        //Disable pushpin dragging in layer.
        setPushpinDraggability(false);
    }
}

function erase() {
    var IsReprocess = false;
    if (setMode('erase')) {
        events.push(Microsoft.Maps.Events.addHandler(fenceLayer, 'click', function (e) {
            var selectedfence = e.primitive;
            var message = '';
            if (currentFence == null)
                message = 'The geofence will be permanently deleted. Continue?';
            else
                message = "Fence ID '" + currentFence.Tag + "' will be permanently deleted. Continue?";
            RCNGWindow.ConfirmWindow.showConfirmBox(message, function (e) {
                if (!IsReprocess) {
                    if (currentFence == null) {
                        fenceLayer.remove(selectedfence);//remove from layer
                        //resetDrawing();   
                        eraseMode();
                    }
                    else {
                        GeofenceManagement.DeleteCustomerGeofence(currentFence, fenceLayer, selectedfence);
                        //resetDrawing();                                                
                    }
                    IsReprocess = true;
                    RCNGWindow.ConfirmWindow.close();
                }
            }, function (e) {
                RCNGWindow.ConfirmWindow.close();
            });

        }));
    }
}

function eraseMode() {
    currentFence = null;
    currentMode = null;
    if (!$("#DeletePolygonMode").hasClass("active")) $('#DeletePolygonMode').addClass('active');
    $("#AddGeofenceMode").hide();
    $("#EditGeofenceMode").hide();
    $("#DeleteGeofenceMode").show();
    erase();
}

function resetDrawing() {
    drawingTools.dispose();
    drawingTools = new Microsoft.Maps.DrawingTools(geofenceMap);
    setMode(null);
    $("#AddGeofenceMode").hide();
    $("#EditGeofenceMode").hide();
    $("#DeleteGeofenceMode").hide();
}

function setPushpinDraggability(draggable) {
    var shapes = fenceLayer.getPrimitives();
    for (var i = 0, len = shapes.length; i < len; i++) {
        if (shapes[i] instanceof Microsoft.Maps.Pushpin) {
            shapes[i].setOptions({ draggable: draggable });
        }
    }
}


//Sets the drawing mode, or toggles out of a mode if it is already set. 
//Returns true if the specified mode is new.
function setMode(mode) {
    //Remove all attached events.
    for (var i = 0; i < events.length; i++) {
        Microsoft.Maps.Events.removeHandler(events[i]);
    }
    events = [];
    //Unlock map so incase it has been locked previously.
    //reeferMap.setOptions({ disablePanning: true });
    var state = false;
    if (currentMode === mode || mode == null) {
        //Toggle out of currentMode mode.
        currentMode = null;
        clearSelection('DrawingModes', 'btn btn-outline-secondary');
    } else {
        currentMode = mode;
        state = true;
    }
    resetDrawingState();
    return state;
}

function resetDrawingState() {
    //Stop any current drawing.
    if (currentShape != null && currentShape != undefined) {
        var locs = currentShape.getLocations();
        if (locs.length > 0) {
            drawingTools.finish(function (s) {
                //Add the completed shape to the drawing layer.
                fenceLayer.add(s);
            });
        }
        currentShape = null;
    }
    if (currentMode !== 'edit') {
        //Disable pushpin dragging in layer.
        setPushpinDraggability(false);
    }
}

function validateGeofencePolygon(locs, currentMode, currentFence, GeofencesData) {
    //Api call
    GeofenceManagement.ValidatePolygonGeofence(locs, currentMode, currentFence, GeofencesData);    
}

function drawingFinished(params) {
    if (currentShape != null && currentShape != undefined) {       
        var locs = currentShape.getLocations();
        //var dt = Microsoft.Maps.DrawingTools;
        //var da = dt.DrawingMode;
        if (locs != null && locs != undefined) {
            var latlonArray = [];
            $.each(locs, function (index, value) {
                if (!(latlonArray.indexOf(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9)) > -1))
                    latlonArray.push(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9));
            });
            if (latlonArray.length > 12) {
                PopupWindow.showErrorMessage("Alert", "Maximum of 12 points is allowed.");
            }
            else if (latlonArray.length < 3) {
                PopupWindow.showErrorMessage("Alert", "Minimum of 3 points is required.");
            }
            else 
                validateGeofencePolygon(locs, currentMode, currentFence, GeofencesData); 
        }
    }
}

function displayFenceInfoboxOnClick(event, selectedFence, polygon) {
    currentFence = selectedFence;
    if (event.targetType == "polygon" && (currentMode == 'polygon' || currentMode == null)) {
        try {
            var dataItem = null;

            for (var i = 0; i < GeofencesData.length; i++) {
                if (GeofencesData[i].GeofenceHistoryID.toString() == selectedFence.GeofenceHistoryID.toString()) {
                    dataItem = GeofencesData[i];
                    break;
                }
            }

            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);
            var popOffset = new Microsoft.Maps.Point(-4, 100);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.PinInfoboxFenceLocation, { selectedPin: dataItem, divid: identityCode, source: "GeofenceMgmt" });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 80,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: new Microsoft.Maps.Location(center.latitude, center.longitude),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = geofenceMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = geofenceMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = geofenceMap.tryLocationToPixel(geofenceMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                geofenceMap.setView({ center: geofenceMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function GenerateAlphaNumericCode(length) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        result = ""
    for (var i = length; i > 0; --i)
        result += chars[Math.round(Math.random() * (chars.length - 1))]
    return result
}

export default GeofenceMap;